module.exports = __webpack_public_path__ + "img/nav-budget-2.bd8a26f.svg";